export class MessageBubble {
   public msg?: string;
   public sender?: boolean;
   public author?: string;
   public date?: string;

   public constructor(init?: Partial<MessageBubble>) {
    Object.assign(this, init);
  }
}
